import apiClient from '@/api/client';

export const AuthUserService = {
  async getRoles(): Promise<AuthUserRolesResponse> {
    const response = await apiClient.get<AuthUserRolesResponse>('/auth/user/roles');
    const result = response.data

    if (!result) {
        throw new Error('Failed to get user roles.');
    }

    return result;
  },
  
  async getUser(): Promise<AuthUserResponse> {
    const response = await apiClient.get<AuthUserResponse>('/auth/user');
    const result = response.data

    if (!result) {
        throw new Error('Failed to get current user.');
    }

    return result;
  }
}

export interface AuthUserRolesResponse {
    roles: string[]
}

export interface AuthUserResponse {
    email: string
    partnerId: number
    partnerName: string
    roles: string[]
}